import { OTHER_SERVICE_CATEGORY_LIST } from '../../../../common/constants';
import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ valuesField, methods, formProps }) => {
  const { intl } = formProps || {};

  return {
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'service.nameService' }),
      placeholder: intl.formatMessage({ id: 'service.nameServiceEnter' }),
      propsWrapper: { xs: true },
      style: { minWidth: 220 },
      readOnly: valuesField.type === OTHER_SERVICE_CATEGORY_LIST.insured,
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'info',
      fields: ['name'],
    },
  ];
};

export const listServiceFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
